// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"eecceb78","329":"49307aa7","596":"1bdc5b2d"}[chunkId] + ".chunk.js";
};